import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, FuelIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} comprehensive volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-green-900" data-id="element-107" data-mp="s9zybf8tt2lo">
      <div className="h-1.5 w-full bg-amber-500" aria-hidden="true" data-id="element-108" data-mp="ncq1vfn0rqoc" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-109" data-mp="nekqp51ew2xp">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-amber-400/50 bg-green-950/60 px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-amber-400" data-id="element-110" data-mp="3czfny6wb6l9q">
          <FuelIcon className="h-4 w-4" aria-hidden="true" data-id="element-111" data-mp="399bcfr77pjxk" /> {productShortName}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.08] text-stone-50 sm:text-5xl lg:text-6xl" data-id="element-112" data-mp="3e8ecsyc8z1z7">
          Master your year of Oil &amp; Gas education
          <br data-id="element-113" data-mp="2vi53z5lygbyj" />
          <span className="text-amber-400" data-id="element-114" data-mp="2vjzmyedo1tzz">in one afternoon.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-115" data-mp="2hix224yeqpqn">
          <img src={productImage} alt="Oil & Gas Industry Teacher Ready: nine volumes and five bonus resources covering industry fundamentals, petroleum geology, drilling, production, refining, midstream, safety and environment, economics and energy transition, and teaching" className="mx-auto w-full drop-shadow-2xl" data-id="element-116" data-mp="s44ifoom7nif" />
        </motion.div>

        <div className="mt-9" data-id="element-117" data-mp="1b04bl2tbwx3l">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-118" data-mp="161szsmjh4ciq">
            Get your teacher ready now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-stone-50" data-id="element-119" data-mp="11150zep06rdy">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-stone-50/15 bg-green-950/50 px-3 py-2" data-id="element-120" data-mp="3lsoyezdi9t7k">
              <Icon className="h-3.5 w-3.5 text-amber-400" aria-hidden="true" data-id="element-121" data-mp="3htpwzoqzgekv" />
              {label}
            </li>)}
        </ul>

        <p className="mt-6 text-xs font-semibold uppercase tracking-[.14em] text-green-100/80" data-id="element-122" data-mp="21by0zcwfr6f1">
          Created by Oil &amp; Gas education specialists, for educators worldwide · Updated 2026
        </p>
      </div>
    </section>;
}